import React, { useState, useEffect, useContext } from 'react';
import { View, StyleSheet, TextInput, Alert, FlatList, TouchableOpacity } from 'react-native';
import colors from '../config/colors';
import connectionConfig from "../config/settings";
import configurationPost from '../config/configurationPost';
import { ListItemAccount, ListItemSeparator, NotificationListItem } from "../components/lists";
import routes from '../navigation/routes';
import ActivityIndicator from '../components/ActivityIndicator';
import dateNow from '../utility/dateNow';
import Icon from '../components/Icon';
import AuthContext from '../auth/context';

var dateRow = ''
var currentDay = ''
var dateComparation = ''
var textDate = ''
var dif = 0

function NotificationTypeScreen(props) {
    useEffect(() => {
    console.log('props.route.params.name -> ', props.route.params.name)
    if(props.route.params.name === 'creation'){
       getNotifications()
    }
    if(props.route.params.name === 'seedling'){
      getNotificationsAddActionSeed()
    }
    if(props.route.params.name === 'brain'){
      getNotificationsLikes()
    }
    if(props.route.params.name === 'comments'){
      getNotificationsComments()
    }   
    if(props.route.params.name === 'present'){
      getNotificationsFollowerSeed()
    }   
    }, [])
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(false);
  const { user } = useContext(AuthContext);
  const date = dateNow();
  var profileUri = connectionConfig.imageUrl + '/PerfilDeUsuario/'
//-----------------------------------------------------------------
//Servicio que va por la lista de notificaciones a semillas creadas
//  '	Amigos creando '
//-----------------------------------------------------------------
const getNotifications = async () => {
    setLoading(true)
    debugger
    
    var post_values = {
        //userId : props.route.params.userIdListing
        userId: JSON.parse(user).userId
    }
    configurationPost.body = JSON.stringify(post_values)
    await fetch(connectionConfig.apiUrl + '/SelectNotificationsList/', configurationPost)
        .then(response => response.json())
        .then(response => {
            setItems(response.data)
            setLoading(false)
            // console.log('select regresa', response)
        })
        .catch(err => {
            console.log('fixo failed :( review internet service -> /SelectNotificationsList/', err)
        })
}
//-----------------------------------------------------------------
//Servicio que va por la lista de notificaciones acciones agregadas las semillas 
//  '		Agregaron algo en tus semillas o acciones '
//-----------------------------------------------------------------
const getNotificationsAddActionSeed = async () => {
  setLoading(true)
  // debugger
  var post_values = {
      //userId : props.route.params.userIdListing
      userId: JSON.parse(user).userId
  }
  configurationPost.body = JSON.stringify(post_values)
  await fetch(connectionConfig.apiUrl + '/SelectNotificationsActionSeedList/', configurationPost)
      .then(response => response.json())
      .then(response => {
          setItems(response.data)
          setLoading(false)
          // console.log('select regresa', response)
      })
      .catch(err => {
          console.log('fixo failed :( review internet service -> /SelectNotificationsActionSeedList/', err)
      })
}
//------------------------------------------------------------------
//Servicio que va por la lista de notificaciones de likes a semillas
// 	'Alguien le dio like a una de tus creaciones'
//------------------------------------------------------------------
const getNotificationsLikes = async () => {
  setLoading(true)
  // debugger
  var post_values = {
      //userId : props.route.params.userIdListing
      userId: JSON.parse(user).userId
  }
  configurationPost.body = JSON.stringify(post_values)
  await fetch(connectionConfig.apiUrl + '/SelectNotificationsLikeList/', configurationPost)
      .then(response => response.json())
      .then(response => {
          setItems(response.data)
          setLoading(false)
          // console.log('select regresa', response)
      })
      .catch(err => {
          console.log('fixo failed :( review internet service -> /SelectNotificationsLikeList/', err)
      })
}

//------------------------------------------------------------------
//Servicio que va por la lista de notificaciones para los comentarios a
// semillas
// 	'Comentarios a tus creaciones'
//------------------------------------------------------------------
const getNotificationsComments = async () => {
  setLoading(true)
  // debugger
  var post_values = {
      //userId : props.route.params.userIdListing
      userId: JSON.parse(user).userId
  }
  configurationPost.body = JSON.stringify(post_values)
  await fetch(connectionConfig.apiUrl + '/SelectNotificationsCommentsList/', configurationPost)
      .then(response => response.json())
      .then(response => {
          setItems(response.data)
          setLoading(false)
          // console.log('select regresa', response)
      })
      .catch(err => {
          console.log('fixo failed :( review internet service -> /SelectNotificationsCommentsList/', err)
      })
}

//------------------------------------------------------------------
//Servicio que va por la lista de notificaciones acciones agregadas las
// semillas que sigues
// 	'	Agregaron algo en las semillas o acciones que sigues '
//------------------------------------------------------------------
const getNotificationsFollowerSeed = async () => {
  setLoading(true)
  // debugger
  var post_values = {
      //userId : props.route.params.userIdListing
      userId: JSON.parse(user).userId
  }
  configurationPost.body = JSON.stringify(post_values)
  await fetch(connectionConfig.apiUrl + '/SelectNotificationsFollowerActionSeed/', configurationPost)
      .then(response => response.json())
      .then(response => {
          setItems(response.data)
          setLoading(false)
          // console.log('select regresa', response)
      })
      .catch(err => {
          console.log('fixo failed :( review internet service -> /SelectNotificationsCommentsList/', err)
      })
}
  const compareDate = (itemDate, index) => {
          currentDay = date.substring(0, 11).replace('/', '').replace('/', '')
          let firstRow  = items[index].dateNotification.substring(0,11).replace('/', '').replace('/', '')
          dif = parseInt(currentDay, 10) - parseInt(firstRow, 10)
  
          if (dif === 0) {
            console.log('Hoy - ', dif)
            textDate = 'Hoy'
            items[index].textCut = 'Hoy ' + itemDate.substring(11, 21)
          }
          if (dif === 1) {
            console.log('Ayer - ', dif)
            textDate = 'Ayer '  + itemDate.substring(11, 21)
            items[index].textCut = 'Ayer ' + itemDate.substring(11, 21)
          }
          if (dif > 1) {
            items[index].textCut =  items[index ].dateNotification
      }
      dateComparation = dateRow
  }
  return (
    <View style={styles.container}>
      <ActivityIndicator visible={loading} />
      <NotificationListItem
            title={props.route.params.type}
            IconComponent={<Icon name={props.route.params.name} 
                                 size={props.route.params.size} 
                                 iconFamily={props.route.params.iconFamily} 
                                 backgroundColor={props.route.params.backgroundColor} 
                            />
                          }
          />
      <FlatList
        data={items}
        keyExtractor={(items) => items.notificationsId.toString()}
        renderItem={({ item, index }) => (
          <NotificationListItem
            image={profileUri + item.IdUserByNotification + '_' + item.userPhoto}
            title={item.descripNotification}
            compareDate ={               
                 compareDate(item.dateNotification, index)
            }
            subTitle={
                item.textCut
            }
            onPress={() => {
              var screen = "ListingsSeedsScreen"
              var seedId = items[index].seedId
              props.navigation.navigate(routes.SEED_DETAILS, {seedId, item, index, screen })
            }}
          >
          </NotificationListItem>
        )}>
      </FlatList>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    marginTop:'3%',
    flex: 1,

  },
  containerSearch: {
    marginTop: "5%",
    flexDirection: "row",
    width: "100%",
    height: "10%"
  },
  input: {
    borderWidth: 1,
    borderColor: colors.medium,
    paddingLeft: 5,
    borderRadius: 5,
    width: "80%",
  },
  icon: {
    alignSelf: "center",
    margin: 10,
    width: "10%",
  }
})

export default NotificationTypeScreen;